import Vue from "vue";
import VueRouter from "vue-router";
import { Toast } from "vant";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { keepAlive: true }
  },

  // 可以在这里添加更多路由
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

 
  
  // 首先检查是否需要添加appId参数
  if (from.query.appId && !to.query.appId && from.path !== to.path) {
  
    const newQuery = { ...to.query, appId: from.query.appId };
    next({ path: to.path, query: newQuery, replace: true });
    return;
  }

  // 首页和规则页面允许直接访问
  if (to.path === "/" || to.path === "/champion-rules") {
    
    next();
    return;
  }

  

  Toast({ message: "请先登录", duration: 2 * 1000 });
  // 在重定向时也保留appId参数
  const redirectQuery = { redirect: to.fullPath };
  if (to.query.appId) {
    redirectQuery.appId = to.query.appId;
  } else if (from.query.appId) {
    redirectQuery.appId = from.query.appId;
  }
  console.log('Redirect query:', redirectQuery);
  next({ path: "/", query: redirectQuery });
});

export default router
